// extracted by mini-css-extract-plugin
export default {"CouldNotFindFallbackErrorContainer":"CouldNotFindFallbackError-module__CouldNotFindFallbackErrorContainer--zMCfj"};